module.exports = __webpack_public_path__ + "static/media/dais.6a1f8808.JPG";